export interface CategoryData {
  id: string;
  name: string;
  slug: string;
  description: string;
  image: string;
  icon: string;
  tournamentCount: number;
}

export const categories: CategoryData[] = [
  {
    id: 'lol',
    name: '英雄联盟',
    slug: 'lol',
    description: '全球最受欢迎的电竞项目，涵盖LPL、LCK、LEC等顶级联赛赛事信息与数据分析',
    image: 'https://readdy.ai/api/search-image?query=League%20of%20Legends%20esports%20arena%20with%20summoners%20rift%20displayed%20on%20giant%20screen%2C%20professional%20gaming%20tournament%2C%20dramatic%20stage%20lighting%2C%20dark%20atmosphere&width=800&height=450&seq=cat-lol-01&orientation=landscape',
    icon: 'ri-gamepad-line',
    tournamentCount: 48,
  },
  {
    id: 'cs2',
    name: 'CS2',
    slug: 'cs2',
    description: 'FPS竞技巅峰，覆盖IEM、ESL、BLAST等全球顶级CS2赛事，提供实时比赛数据',
    image: 'https://readdy.ai/api/search-image?query=Counter%20Strike%202%20esports%20professional%20match%20on%20stage%2C%20players%20at%20computers%20with%20intense%20focus%2C%20arena%20filled%20with%20fans%2C%20competitive%20gaming%20atmosphere&width=800&height=450&seq=cat-cs2-01&orientation=landscape',
    icon: 'ri-crosshair-line',
    tournamentCount: 36,
  },
  {
    id: 'dota2',
    name: 'DOTA2',
    slug: 'dota2',
    description: '最高奖金池电竞赛事，TI国际邀请赛、Major等重大赛事全程跟踪与深度分析',
    image: 'https://readdy.ai/api/search-image?query=DOTA%202%20esports%20tournament%20with%20teams%20battling%20on%20stage%2C%20golden%20aegis%20trophy%20displayed%2C%20massive%20crowd%20in%20stadium%2C%20epic%20gaming%20event&width=800&height=450&seq=cat-dota-01&orientation=landscape',
    icon: 'ri-shield-line',
    tournamentCount: 28,
  },
  {
    id: 'hok',
    name: '王者荣耀',
    slug: 'hok',
    description: '中国最火爆的移动电竞项目，KPL联赛、世界冠军杯等赛事信息一网打尽',
    image: 'https://readdy.ai/api/search-image?query=Honor%20of%20Kings%20mobile%20esports%20tournament%20in%20China%2C%20players%20on%20stage%20with%20phones%2C%20spectacular%20Chinese%20style%20stage%20design%2C%20huge%20cheering%20crowd&width=800&height=450&seq=cat-hok-01&orientation=landscape',
    icon: 'ri-smartphone-line',
    tournamentCount: 52,
  },
  {
    id: 'valorant',
    name: 'Valorant',
    slug: 'valorant',
    description: '战术射击新星，VCT冠军巡回赛、大师赛等全球赛事深度报道',
    image: 'https://readdy.ai/api/search-image?query=Valorant%20esports%20championship%20event%20with%20teams%20competing%2C%20futuristic%20arena%20with%20neon%20lighting%2C%20professional%20gaming%20atmosphere%2C%20dark%20tone&width=800&height=450&seq=cat-valorant-01&orientation=landscape',
    icon: 'ri-radar-line',
    tournamentCount: 24,
  },
  {
    id: 'pubg',
    name: 'PUBG',
    slug: 'pubg',
    description: '战术竞技巅峰，PGC全球锦标赛、PGS系列赛等顶级赛事实时跟踪',
    image: 'https://readdy.ai/api/search-image?query=PUBG%20esports%20tournament%20with%20professional%20players%20on%20stage%2C%20battle%20royale%20game%20displayed%20on%20screens%2C%20competitive%20gaming%20arena%20with%20dramatic%20lighting&width=800&height=450&seq=cat-pubg-01&orientation=landscape',
    icon: 'ri-shield-flash-line',
    tournamentCount: 20,
  },
  {
    id: 'all',
    name: '全部赛事',
    slug: 'all',
    description: '浏览所有电竞赛事类别，一站式获取全球电竞最新动态与赛事信息',
    image: 'https://readdy.ai/api/search-image?query=epic%20collage%20of%20various%20esports%20games%20including%20League%20of%20Legends%2C%20CS2%2C%20DOTA2%2C%20Valorant%20in%20a%20professional%20arena%20setting%2C%20dramatic%20lighting%2C%20cinematic%20style&width=800&height=450&seq=cat-all-01&orientation=landscape',
    icon: 'ri-global-line',
    tournamentCount: 208,
  },
  {
    id: 'news',
    name: '新闻资讯',
    slug: 'news',
    description: '最新电竞行业动态、赛事新闻、战队变动、选手访谈等综合资讯',
    image: 'https://readdy.ai/api/search-image?query=esports%20newsroom%20with%20journalists%20reporting%20on%20gaming%20events%2C%20multiple%20screens%20showing%20game%20highlights%2C%20professional%20media%20environment%2C%20clean%20modern%20office&width=800&height=450&seq=cat-news-01&orientation=landscape',
    icon: 'ri-newspaper-line',
    tournamentCount: 156,
  },
];